import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { RecapSchedule, browserTz } from "@/components/RecapSchedule";
import { logError } from "@/lib/log";

const TREND = { up: "↑ up", down: "↓ down", flat: "→ steady" };

export const WeeklyRecapCard = () => {
  const [r, setR] = useState(null);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    api.get("/recap/preview").then(async (res) => {
      let data = res.data;
      if (data.recap_timezone === "UTC" && browserTz() !== "UTC") {
        const saved = await api.put("/recap/settings", { recap_timezone: browserTz() });
        data = { ...data, ...saved.data };
      }
      setR(data);
    }).catch((e) => logError("Recap preview failed:", e));
  }, []);

  const save = async (patch, msg) => {
    setR((x) => ({ ...x, ...patch }));
    try {
      const { data } = await api.put("/recap/settings", patch);
      setR((x) => ({ ...x, ...data }));
      toast.success(msg);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const toggle = (v) => save({ weekly_recap_enabled: v }, v ? "Weekly recap turned on" : "Weekly recap turned off");

  const sendNow = async () => {
    setSending(true);
    try { const { data } = await api.post("/recap/send-test"); toast.success(data.message); }
    catch (e) { toast.error(errMsg(e, "Could not send recap")); }
    finally { setSending(false); }
  };

  if (!r) return null;
  return (
    <div className="mm-card p-5" data-testid="weekly-recap-card">
      <div className="flex justify-between items-center gap-3">
        <div>
          <div className="font-semibold flex items-center gap-2"><Mail size={18} /> Weekly email recap</div>
          <div className="text-sm text-mm-muted">Your mood trend, streak and a little encouragement, once a week.</div>
        </div>
        <Switch checked={r.weekly_recap_enabled} onCheckedChange={toggle} data-testid="weekly-recap-toggle" />
      </div>
      <RecapSchedule day={r.recap_day} hour={r.recap_hour} tz={r.recap_timezone} disabled={!r.weekly_recap_enabled}
        onChange={(patch) => save(patch, "Recap schedule saved")} />
      <div className="grid grid-cols-3 gap-3 mt-4 text-center" data-testid="weekly-recap-preview">
        {[["Check-ins", r.checkins], ["Avg mood", r.avg_mood ?? "—"], ["Trend", TREND[r.trend]]].map(([l, v]) => (
          <div key={l} className="mm-soft py-3"><div className="font-display text-xl font-bold text-mm-primary">{v}</div><div className="text-xs text-mm-muted">{l}</div></div>
        ))}
      </div>
      <p className="text-sm text-mm-muted mt-3 italic">“{r.encouragement}”</p>
      <button className="mm-btn-ghost mt-4" onClick={sendNow} disabled={sending} data-testid="weekly-recap-send-now">
        {sending && <Loader2 size={16} className="animate-spin" />} Email me this week's recap now
      </button>
    </div>
  );
};
